import ConfirmationModal from '@/components/ui-kit/confirmation-modal';
import { useToast } from '@/hooks/use-toast';
import { isErrorWithErrors } from '@/modules/gpt-chats/utils/error';
import { useReembedKb } from '@/modules/gpt-chats/hooks/use-kb';
import { KBType } from '@/modules/gpt-chats/models/kb';
import { Dialog } from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';

type ReembedKbProps = {
  open: boolean;
  onOpenChange: (value: boolean) => void;
  kbs: [{ id: string; type: KBType }];
  onSuccess?: () => void;
  agentId?: string;
};

export const ReembedKb = ({ kbs, open, onOpenChange, onSuccess }: ReembedKbProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();
  const { mutateAsync, isPending } = useReembedKb();

  const confirmHandler = async () => {
    try {
      const res = await mutateAsync({ kbs: kbs });
      if (!res.is_success) return toast.error({ errors: res.error });
      toast.success(t('KNOWLEDGE_BASE_REEMBEDDING_STARTED'));
      onSuccess?.();
      onOpenChange(false);
    } catch (error) {
      if (isErrorWithErrors(error)) return toast.error({ errors: error.errors });
      return toast.error({ errors: t('SOMETHING_WENT_WRONG') });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <ConfirmationModal
        data={{
          dialogTitle: t('RE_EMBED'),
          dialogSubtitle: t('ARE_YOU_SURE_YOU_WANT_TO_RE_EMBED'),
        }}
        onConfirm={confirmHandler}
        onCancel={() => onOpenChange(false)}
        buttonState={{ confirm: { disable: isPending } }}
      />
    </Dialog>
  );
};
